import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FuryCardModule } from '../../../@fury/shared/card/card.module';
import { ClickOutsideModule } from '../../../@fury/shared/click-outside/click-outside.module';
import { MaterialModule } from '../../../@fury/shared/material-components.module';
import { ScrollbarModule } from '../../../@fury/shared/scrollbar/scrollbar.module';
import { ToolbarFullscreenToggleComponent } from './toolbar-fullscreen-toggle/toolbar-fullscreen-toggle.component';
import { ToolbarNotificationsComponent } from './toolbar-notifications/toolbar-notifications.component';
import { ToolbarSidenavMobileToggleComponent } from './toolbar-sidenav-mobile-toggle/toolbar-sidenav-mobile-toggle.component';
import { ToolbarUserComponent } from './toolbar-user/toolbar-user.component';
import { ToolbarComponent } from './toolbar.component';
import { ToolbarSidenavDesktopToggleComponent } from './toolbar-sidenav-desktop-toggle/toolbar-sidenav-desktop-toggle.component';
import { ToolbarDarkmodeToggleComponent } from './toolbar-darkmode-toggle/toolbar-darkmode-toggle.component';
import { ToolbarUserAvailabilityComponent } from './toolbar-user-availability/toolbar-user-availability.component';
import { OtherAppsDialogComponent } from './toolbar-user/other-apps-dialog/other-apps-dialog.component';
import { LoadingOverlayModule } from '../../../@fury/shared/loading-overlay/loading-overlay.module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    ScrollbarModule,
    FormsModule,
    ClickOutsideModule,
    FuryCardModule,
    ReactiveFormsModule,
    LoadingOverlayModule
  ],
  declarations: [
    ToolbarComponent,
    ToolbarUserComponent,
    ToolbarNotificationsComponent,
    ToolbarFullscreenToggleComponent,
    ToolbarDarkmodeToggleComponent,
    ToolbarSidenavMobileToggleComponent,
    ToolbarSidenavDesktopToggleComponent,
    ToolbarUserAvailabilityComponent,
    OtherAppsDialogComponent,
  ],
  exports: [ToolbarComponent]
})
export class ToolbarModule {
}
